import { TaskTypeDto } from './dto/task-type.dto';
import { ApiService } from '../../shared/api/api.service';
import { Injectable } from '@angular/core';
import { TaskTypeSearchDto } from './dto/task-type-search.dto';
import { PagedResultGeneric } from 'src/app/shared';

@Injectable({
  providedIn: 'root',
})
export class TaskTypeService {
  constructor(private _apiService: ApiService) {}

  get(taskType: string): Promise<TaskTypeDto> {
    return this._apiService.get(`TaskType?taskTypeName=${encodeURIComponent(taskType)}`);
  }

  create(taskType: TaskTypeDto): Promise<string> {
    return this._apiService.post('TaskTypes', taskType);
  }

  update(currentTaskTypeName: string, taskType: TaskTypeDto) {
    return this._apiService.put(`TaskType?taskTypeName=${encodeURIComponent(currentTaskTypeName)}`, taskType);
  }

  delete(taskType: string) {
    return this._apiService.delete(`TaskType?taskTypeName=${encodeURIComponent(taskType)}`);
  }

  search(searchDto: TaskTypeSearchDto): Promise<PagedResultGeneric<TaskTypeDto>> {
    return this._apiService.post('TaskTypes/Search', searchDto);
  }
}
